import api from "../../../services/api";

// Fonte real de "Volume diário de alertas" e "Top equipamentos" — as duas
// rotas compartilham o mesmo motor no backend (alertasPeriodo.js, ver
// PLANO_CENTRAL_ALERTAS.md §9), então buscamos as duas juntas aqui também:
// se chegarem quase ao mesmo tempo, o dedup do backend evita computar 2x.
//
// filterClientes/filterEquipamentos JÁ são enviados (mesma nota de
// apiKpis.js): os dropdowns usam ids reais vindos de
// /find/centralAlertas/filtros, honrados pelo backend.
export async function buscarAlertasPeriodo({
	inicio,
	fim,
	filterClientes,
	filterEquipamentos,
	filterSeveridades,
	erpId,
	signal,
}) {
	const body = {
		initial_date: inicio.toISOString(),
		final_date: fim.toISOString(),
		// ERP escolhido no painel (sem ERP cadastrado: a variável ERP).
		erpId: erpId || undefined,
		...(filterClientes?.length ? { filterClientes } : {}),
		...(filterEquipamentos?.length ? { filterEquipamentos } : {}),
		...(filterSeveridades?.length ? { filterSeveridades } : {}),
	};

	const [volume, top] = await Promise.allSettled([
		api.post("/find/centralAlertas/volumeDiario", body, { signal }),
		api.post("/find/centralAlertas/topEquipamentos", body, { signal }),
	]);

	if (volume.status === "rejected") {
		console.error(
			"Erro ao buscar volume diário de alertas da Central de Alertas:",
			volume.reason
		);
	}
	if (top.status === "rejected") {
		console.error(
			"Erro ao buscar top equipamentos da Central de Alertas:",
			top.reason
		);
	}

	return {
		alertasPorDia: volume.status === "fulfilled" ? volume.value?.data || [] : [],
		rankingEquipamentos: top.status === "fulfilled" ? top.value?.data || [] : [],
	};
}
